/* eslint-disable @typescript-eslint/no-misused-promises */
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';
import $ from 'jquery';

interface IMapService {
	map?: google.maps.Map;
	geocoder?: google.maps.Geocoder;
	checkReference(): Promise<void>;
	getGeocoder(): Promise<google.maps.Geocoder>;
}

export default class MapService implements IMapService {
	public map?: google.maps.Map;
	public geocoder?: google.maps.Geocoder;

	public checkReference(): Promise<void> {
		return new Promise((resolve) => {
			if (!window.google?.maps) {
				const url = new URL(
					'https://maps.googleapis.com/maps/api/js?v=3.21&libraries=places,geometry&channel=aem-web'
				);
				const googleApis = window.lt.api?.googleapis as ltFramework.IDictionary | undefined;
				url.searchParams.append('key', googleApis?.key ?? '');
				const jQueryPromise = $.getScript(url.toString());
				return new Promise<void>((resolver) => {
					return jQueryPromise.always(() => {
						resolver();
					});
				});
			}
			else {
				resolve();
			}
		});
	}

	public getGeocoder(): Promise<google.maps.Geocoder> {
		return new Promise((resolve) => {
			return this.checkReference().then(() => {
				this.geocoder = new window.google.maps.Geocoder();
				resolve(this.geocoder);
			});
		});
	}
}

export const mapService = new MapService();
